import React from "react"
import NewsFeaturedHero from "./NewsFeaturedHero"
import { Link } from "gatsby"
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { AiFillTag } from "react-icons/ai"
import NewsSlider from "./NewsSlider"
import TextMarqueeBannerPostNMCat from "../../utils/TextMarqueeBannerPostNMCat"

import { motion } from "framer-motion"

const NewsFeatured2 = ({ cardHeroTitles, type }) => {
  const { allStrapiArticle, allStrapiCategory } = useStaticQuery(graphql`
    {
      allStrapiArticle(limit: 18, sort: {date: DESC}) {
        nodes {
          id
          slug
          title
          description
          subtitle
          date
          cover {
            alternativeText
            localFile {
              childImageSharp {
                gatsbyImageData(layout: CONSTRAINED)
              }
            }
          }
        }
      }
      allStrapiCategory(
        filter: { articles: { elemMatch: { isFeatured: { eq: true } } } }
      ) {
        nodes {
          slug
          name
        }
      }
    }
  `)

  const cardNews = allStrapiArticle.nodes

  const gridAnimate = {
    offScreen: { opacity: 0, x: 50 },
    onScreen: {
      opacity: 1,
      x: 0,
      transition: { type: "spring", bounce: 0.4, duration: 2 },
    },
  }

  const opacity = {
    offScreen: { opacity: 0 },
    onScreen: {
      opacity: 1,
      transition: { type: "spring", bounce: 0.4, duration: 2 },
    },
  }

  return (
    <>
      <div className="newsSlider">
        <NewsSlider />
      </div>
      <TextMarqueeBannerPostNMCat  articleTag={allStrapiCategory} />
      <div className={`container-orange flex-news`}>
        <div className="grid-news-left">
          <NewsFeaturedHero />
        </div>
        <motion.div
          className="grid-news-right"
          variants={gridAnimate}
          initial={"offScreen"}
          whileInView={"onScreen"}
          transition={{ staggerChildren: 0.2 }}
        >
          {cardNews?.map((blog, index) => {
            const pathToImage = getImage(blog.cover.localFile)
            return (
              <motion.div
                key={index}
                className="card"
                variants={opacity}
                initial={"offScreen"}
                whileInView={"onScreen"}
                transition={{ staggerChildren: 0.2 }}
              >
                <Link to={`/blog/${blog.slug}`}>
                  <div className="card-image">
                    <GatsbyImage
                      image={pathToImage}
                      alt={blog.cover.alternativeText}
                    />
                  </div>
                </Link>
                <div className="card-info">
                  <Link to={`/blog/${blog.slug}`}>
                    <h2 className="card-title">{blog.title}</h2>
                  </Link>
                  <div className={`show description`}>
                    <p className="card-body">{blog.description}</p>
                    <div className="ref">
                      <Link to={`/blog/${blog.slug}`}>
                        <div className="button">Leer Más</div>
                      </Link>
                    </div>
                    <div className="card-info-bottom">
                      <div className="tag">
                        <AiFillTag className="tag-icon" />
                        <span>{allStrapiCategory?.nodes[0]?.name}</span>
                      </div>
                      {/* <div className="date">
                        <BsCalendar3 className="date-icon" />
                        <span>{publishDate}</span>
                      </div> */}
                    </div>
                  </div>
                </div>
              </motion.div>
            )
          })}
        </motion.div>
      </div>
      {/* <NewsScrollCard/> */}
      {/* <NewsFeaturedText /> */}
    </>
  )
}

export default NewsFeatured2
